export const ROLES = {
  PLATFORM_ADMIN: 'platform_admin',
  ADMIN: 'admin',
  TEACHER: 'teacher',
  STUDENT: 'student',
};

export const ROLE_HOME = {
  [ROLES.PLATFORM_ADMIN]: '/platform',
  [ROLES.ADMIN]: '/admin',
  [ROLES.TEACHER]: '/teacher',
  [ROLES.STUDENT]: '/dashboard',
};

export function normalizeRole(role) {
  if (!role) return ROLES.STUDENT;
  if (role === 'mentor' || role === 'instructor') return ROLES.TEACHER;
  return role;
}

export function homePathForRole(role) {
  const normalized = normalizeRole(role);
  return ROLE_HOME[normalized] || '/dashboard';
}

export function isPlatformRole(user) {
  return user?.role === ROLES.PLATFORM_ADMIN || Boolean(user?.isPlatformDeveloper);
}
